/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { createStore } from "redux";
import { persistStore } from "redux-persist";
import { rootReducer } from "reducers";

export default function configureStore() {
  // Defines main Redux store for Skale web app
  if (module.hot) {
    // Enable hot module replacement for reducers
    module.hot.accept(() => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextRootReducer = require("reducers").default;
      store.replaceReducer(nextRootReducer);
    });
  }

  const store = createStore(
    rootReducer,
    // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
  const persistor = persistStore(store);

  return { persistor, store };
}
